import CryptoJS from 'crypto-js';

export const nextDoorEvent = () => {

  document.addEventListener('wpcf7mailsent', function (event) {
    var email = event.detail.inputs.filter(function (input) {
      return input.name === 'client_email';
    })[0].value;


    // Trim whitespace and convert the email to lowercase before hashing
    var email = email.trim().toLowerCase();
    // Hash the email
    var hashedEmail = CryptoJS.SHA256(email).toString(CryptoJS.enc.Hex);


    ndp('init', '3ad23803-3e4a-41a1-a11e-f97ca59d5533', {
      // user_email: email,
      user_email_hash: hashedEmail
    });
    ndp('track', 'CONVERSION');

  }, false);

}